import { DbRow } from "../../../../adl-gen/common/adminui/api";
import { JsonBinding } from "../../../../adl-gen/runtime/json";

export type PlacementImportMode = "create" | "update";

export type PlacementImportParsed = {
  mode: PlacementImportMode;
  id?: string;
  values: DbRow;
};

function extractPlacementId(raw: Record<string, unknown>): string | undefined {
  const id = raw.id;
  if (typeof id === "string" && id.trim() !== "") {
    return id.trim();
  }
  return undefined;
}

/**
 * Converts one placement object from batch JSON into a create or update payload.
 * Objects with a non-empty `id` are updates; others are creates (id stripped).
 */
export function parsePlacementImportJson(raw: unknown): PlacementImportParsed {
  if (raw === null || typeof raw !== "object" || Array.isArray(raw)) {
    throw new Error("Each placement must be a JSON object");
  }
  const obj = raw as Record<string, unknown>;
  const id = extractPlacementId(obj);
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (k !== "id") {
      out[k] = v;
    }
  }
  const now = Date.now();
  if (id === undefined) {
    if (out.created === undefined) {
      out.created = now;
    }
    if (out.updated === undefined) {
      out.updated = now;
    }
    return { mode: "create", values: out as DbRow };
  }
  out.updated = now;
  return { mode: "update", id, values: out as DbRow };
}

/**
 * Normalize a placement for batch-upload-compatible JSON export via jsonBinding.
 */
export function toPlacementExportJson(
  id: string,
  jsonBinding: JsonBinding<Record<string, unknown>>,
  dbRow: DbRow
): Record<string, unknown> {
  try {
    const normalized = jsonBinding.toJson(
      jsonBinding.fromJsonE(dbRow)
    ) as Record<string, unknown>;
    return { id, ...normalized };
  } catch {
    return { id, ...(dbRow as Record<string, unknown>) };
  }
}
